var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFraktklass1500(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": 1500
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 32",
    d: "M3.818 22.14h.879c0-.005 1.182-2.592 2.777-2.592s2.731 2.592 2.731 2.592h10.462V7.559h-20V22.14Z",
    fill: "#aeffb3"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 30",
    d: "M4.079 12.074v.3c0 .407-.2.566-.59.566h-.686v.869h1.276v3.823h1.076v-5.558Zm4.609 1.706a1.6 1.6 0 0 0-.758.175l.159-.853h2.273v-1.028H7.205l-.542 2.942 1 .247a.96.96 0 0 1 .877-.478.833.833 0 0 1 .917.893.92.92 0 0 1-.933 1 .933.933 0 0 1-.969-.846l-1.061.175a2.02 2.02 0 0 0 2.05 1.712 2.05 2.05 0 0 0 2.065-2.041 1.88 1.88 0 0 0-1.921-1.898m4.234 3.931c1.675 0 1.938-1.627 1.938-2.871 0-1.22-.263-2.863-1.97-2.863-1.778 0-1.946 1.73-1.946 2.855 0 1.149.184 2.879 1.978 2.879m-.016-1.036c-.8 0-.853-.917-.853-1.818 0-.941.056-1.842.837-1.842s.845.893.845 1.834c0 .901-.056 1.826-.829 1.826m4.338 1.036c1.675 0 1.938-1.627 1.938-2.871 0-1.22-.263-2.863-1.97-2.863-1.778 0-1.946 1.73-1.946 2.855 0 1.149.184 2.879 1.978 2.879m-.016-1.036c-.8 0-.853-.917-.853-1.818 0-.941.056-1.842.837-1.842s.845.893.845 1.834c0 .901-.056 1.826-.829 1.826"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8",
    d: "M7.414 25.606a3.322 3.322 0 1 1 3.322-3.322 3.326 3.326 0 0 1-3.322 3.322m0-5.316a1.993 1.993 0 1 0 1.993 1.993 2 2 0 0 0-1.993-1.993"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9",
    d: "M24.69 25.606a3.322 3.322 0 1 1 3.322-3.322 3.326 3.326 0 0 1-3.322 3.322m0-5.316a1.993 1.993 0 1 0 1.993 1.993 2 2 0 0 0-1.993-1.993"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10",
    d: "M20.7 22.948a.664.664 0 0 1-.664-.664V8.462a.4.4 0 0 0-.337-.133H1.666a.4.4 0 0 0-.338.138v13.019a.4.4 0 0 0 .337.133h2.981a.665.665 0 0 1 0 1.329h-2.98A1.576 1.576 0 0 1 0 21.486V8.462A1.576 1.576 0 0 1 1.666 7H19.7a1.576 1.576 0 0 1 1.666 1.462v13.821a.664.664 0 0 1-.666.665"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11",
    d: "M20.703 22.948H10.072a.665.665 0 1 1 0-1.329h10.631a.665.665 0 0 1 0 1.329"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12",
    d: "M30.539 22.948h-2.526a.665.665 0 0 1 0-1.329h2.526a.133.133 0 0 0 .132-.132v-3.686a.1.1 0 0 0-.012-.054l-2.378-5.352a.13.13 0 0 0-.121-.079h-7.457a.665.665 0 1 1 0-1.329h7.456a1.46 1.46 0 0 1 1.336.868l2.379 5.352a1.45 1.45 0 0 1 .126.594v3.686a1.464 1.464 0 0 1-1.461 1.461"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13",
    d: "M22.032 22.948h-1.329a.665.665 0 0 1 0-1.329h1.329a.665.665 0 1 1 0 1.329"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4",
    fill: "none",
    d: "M0 0h32v32H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFraktklass1500);
export default __webpack_public_path__ + "static/media/fraktklass-1500.4c15c6e358ff7f8ef81ca3402e8bb09a.svg";
export { ForwardRef as ReactComponent };